import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/mailbox/')({
  beforeLoad: () => {
    throw redirect({ to: '/mailbox/incoming', search: true });
  },
});
